import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";
import TornaAlMenu from "../components/TornaAlMenu";
import DeleteAccountModal from "../components/DeleteAccountModal";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function AppAccountPage() {
  const navigate = useNavigate();

  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteAccepted, setDeleteAccepted] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setErr("");

      try {
        const res = await authFetch(`${API_URL}/api/me/`);
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.detail || "Impossibile caricare il profilo.");
        }

        setMe(data);
      } catch (error) {
        setErr(error?.message || "Errore durante il caricamento del profilo.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const logout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("me.username");
    localStorage.removeItem("me.role");
    localStorage.removeItem("me.store_name");
    localStorage.removeItem("session_only");

    sessionStorage.removeItem("access");
    sessionStorage.removeItem("refresh");

    window.location.replace("/app");
  };

  const requestEmailChange = () => {
    navigate("/app/beta", {
      state: {
        presetSubject: "Richiesta modifica email account",
        presetMessage:
          "Richiedo la modifica dell'indirizzo email associato al mio account. Verrò in negozio per la verifica dell'identità.",
      },
    });
  };

  const requestAccountDeletion = () => {
    setDeleteAccepted(false);
    setShowDeleteModal(true);
  };

  const continueAccountDeletion = async () => {
    if (!deleteAccepted) return;

    try {
      setErr("");

      const res = await authFetch(
        `${API_URL}/api/app/account/delete-request/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            reason: "",
          }),
        }
      );

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(
          data?.detail || "Errore durante l'invio della richiesta."
        );
      }

      setShowDeleteModal(false);
      setDeleteAccepted(false);

      window.alert(
        data?.detail ||
          "Richiesta di eliminazione account inviata correttamente."
      );
    } catch (error) {
      setErr(
        error?.message ||
          "Errore durante l'invio della richiesta di eliminazione account."
      );
    }
  };

  if (loading) {
    return (
      <div className="container py-4" style={{ maxWidth: 760 }}>
        <TornaAlMenu to="/app" />
        <div className="text-muted mt-3">Caricamento account...</div>
      </div>
    );
  }

  if (err) {
    return (
      <div className="container py-4" style={{ maxWidth: 760 }}>
        <TornaAlMenu to="/app" />
        <div className="alert alert-danger mt-3">{err}</div>
      </div>
    );
  }

  return (
    <div className="container py-4" style={{ maxWidth: 760 }}>
      <TornaAlMenu to="/app" />

      <div className="card border-0 shadow-sm rounded-5 overflow-hidden mt-3">
        <div
          className="card-body p-4 text-center"
          style={{
            background:
              "linear-gradient(135deg, #8b1e2d 0%, #5b0f1b 55%, #211014 100%)",
            color: "#fff",
          }}
        >
          <div style={{ fontSize: 52 }}>👤</div>
          <h2 className="fw-bold mt-2 mb-1">Account e sicurezza</h2>
          <div style={{ opacity: 0.8 }}>
            Gestisci il tuo profilo e la sicurezza dell'account.
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-5 mt-3">
        <div className="card-body p-4">
          <h4 className="fw-bold mb-3">I tuoi dati</h4>

          <div className="mb-3">
            <div className="small text-muted">Nome</div>
            <div className="fw-semibold fs-5">{me?.first_name || "-"}</div>
          </div>

          <div className="mb-3">
            <div className="small text-muted">Cognome</div>
            <div className="fw-semibold fs-5">{me?.last_name || "-"}</div>
          </div>

          <div className="mb-3">
            <div className="small text-muted">Email</div>
            <div className="fw-semibold fs-5 text-break">{me?.email || "-"}</div>
          </div>

          <div className="mb-3">
            <div className="small text-muted">Username</div>
            <div className="fw-semibold fs-5 text-break">{me?.username || "-"}</div>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-5 mt-3">
        <div className="card-body p-4">
          <h4 className="fw-bold mb-3">Stato account</h4>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <span>Account</span>
            <span className="badge bg-success rounded-pill">Verificato</span>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <span>Tipo account</span>
            <strong>{me?.role_label || me?.role || "CLIENTE"}</strong>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <span>Punto vendita</span>
            <strong className="text-end">
              {me?.punto_vendita || me?.store?.display_name || "Dallo Zio Roby"}
            </strong>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <span>Versione app</span>
            <strong>1.0.0</strong>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-5 mt-3">
        <div className="card-body p-4">
          <h4 className="fw-bold mb-3">Sicurezza</h4>

          <div className="d-grid gap-2">
            <button
              type="button"
              className="btn btn-outline-dark rounded-pill py-3 fw-semibold"
              onClick={() => navigate("/force-change-password")}
            >
              🔑 Cambia password
            </button>

            <button
              type="button"
              className="btn btn-outline-dark rounded-pill py-3 fw-semibold"
              onClick={requestEmailChange}
            >
              ✉️ Richiedi modifica email
            </button>

            <button
              type="button"
              className="btn btn-outline-danger rounded-pill py-3 fw-semibold"
              onClick={logout}
            >
              🚪 Logout
            </button>
          </div>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-5 mt-3 mb-4">
        <div className="card-body p-4">
          <h4 className="fw-bold mb-3">Privacy e account</h4>

          <div className="d-grid gap-2">
            <button
              type="button"
              className="btn btn-light rounded-pill py-3 fw-semibold"
              onClick={() =>
                window.open(
                  "https://gestionale.dallozioroby.it/privacy",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              📄 Informativa Privacy
            </button>

            <button
              type="button"
              className="btn btn-light rounded-pill py-3 fw-semibold text-danger"
              onClick={requestAccountDeletion}
            >
              🗑 Richiedi eliminazione account
            </button>
          </div>
        </div>
      </div>
      <DeleteAccountModal
        show={showDeleteModal}
        accepted={deleteAccepted}
        onAccepted={setDeleteAccepted}
        onClose={() => {
          setShowDeleteModal(false);
          setDeleteAccepted(false);
        }}
        onConfirm={continueAccountDeletion}
      />

    </div>
  );
}
